import type { SVGProps } from 'react'
const SvgSyArrowLeftSystem = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width={24} height={24} {...props}>
		<path d="m6 10.7 7-7-1.8-1.8L1 12l10.1 10.1 1.8-1.8-7-7h17v-2.6z" />
	</svg>
)
export default SvgSyArrowLeftSystem
